import { FunctionComponent } from 'react'
import styles from './auth.module.scss'
import Title from '@/components/_custom/Title/title'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { useTranslation } from 'react-i18next'
import Link from '@/components/_custom/Link/Link'

interface SignUpProps {
    returnToLogin: () => void
    email: string
    role?: string
}

const SignupMobile: FunctionComponent<SignUpProps> = ({ returnToLogin, email, role }: SignUpProps) => {
    const { t } = useTranslation()

    const linkHref: string = `https://app.cald.fr/?signup=${email}${role ? `&role=${role}` : ''}`

    return (
        <div className={styles.Form}>
            <div className={styles.Title}>
                <Title text={t('signUp')} />
            </div>
            <div className={styles.Input}>
                <p className={styles.TextSignUP}>
                    {' '}
                    {t('mobileSignUp')} <span className={styles.Span}>{email}</span>
                </p>
            </div>
            <Link href={linkHref} className={styles.Input}>
                <ButtonText text={t('myRegister')} onClick={() => {}} fullWidth />
            </Link>
            <a className={styles.Link} onClick={returnToLogin}>
                {t('returnToLogin')}
            </a>
        </div>
    )
}

export default SignupMobile
